// extracted by mini-css-extract-plugin
export default {"LogicalRelationWrapper":"LogicalRelationSelector_LogicalRelationWrapper__-Mjh9","Button":"LogicalRelationSelector_Button__3JN54","Active":"LogicalRelationSelector_Active__Bb3Fs"};